import classNames from "classnames";
import React from "react";
import { SettingsForm } from "../../../settingsForm";
import styles from "./elementForm.css";

interface Props extends React.PropsWithChildren<{}> {
  className?: string;
  /** When provided will render with SettingsForm, when true will prevent tab change */
  isEdited?: boolean;
}
export const ElementForm = ({ isEdited, className, children }: Props) => {
  const renderForm = () => (
    <div className={classNames(styles.container, className, { [styles.edit]: isEdited })}>
      {children}
    </div>
  );

  const renderEditable = () => (
    <SettingsForm withoutSaveDiscardButtons disabled={!isEdited}>
      {renderForm()}
    </SettingsForm>
  );

  return isEdited !== undefined ? renderEditable() : renderForm();
};
